
import { defineComponent, PropType } from 'vue'
import { mapActions } from 'vuex'
import { OrgUsersActions } from '~/store/control-panel/users'
import { EnterpriseUser } from '~/types/types'
import MutationFailedError from '~/utils/mutationFailedError'

export default defineComponent({
  name: 'ToggleUserActiveButton',
  props: {
    orgUser: {
      type: Object as PropType<EnterpriseUser>,
      required: true
    }
  },
  data() {
    return {
      showToggleUserActiveButton: false,
      isTogglingUser: false
    }
  },
  methods: {
    ...mapActions('control-panel/users', {
      toggleUserActive: OrgUsersActions.TOGGLE_USER_ACTIVE
    }),
    showConfirm() {
      this.showToggleUserActiveButton = true
    },
    async toggleUser(userId: string, isActive: boolean, close: () => void) {
      this.isTogglingUser = true
      try {
        const response = await this.toggleUserActive({ userId, isActive })
        if (!response) {
          throw new MutationFailedError(
            `An error occured while ${
              isActive ? 'activating' : 'deactivating'
            } user, please try again.`
          )
        }
        this.$toast.success(`User ${isActive ? 'activated' : 'deactivated'} succesfully.`)
      } catch (e) {
        this.$toast.danger((e as Error).message)
      } finally {
        this.$emit('refetch')
        if (close) close()
        this.isTogglingUser = false
      }
    }
  }
})
